export const MAX_SIZE_MB = 5;

export const PROFILE_REQUIRED_FIELDS = [
  'first_name',
  'last_name',
  'private_phone',
  'work_phone',
  'backup_email',
  'address_id'
];

export const USER_INVITATION_STATUSES = {
  PENDING: 'pending',
  ACTIVE: 'active',
  ARCHIVED: 'archived'
};
